var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "price-table uk-margin-remove-top uk-table uk-table-divider uk-table-justify"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "uk-table-shrink"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('fields.organization')) + "\n      ")]), _vm._v(" "), _c('th', {
    staticClass: "uk-text-right uk-table-shrink"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('fields.value')) + "\n      ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('fields.paymentFrequency')))]), _vm._v(" "), (_vm.showActions) ? _c('th') : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.prices), function(price, index) {
    return _c('tr', [(price.organization) ? _c('td', [(_vm.isAuthenticatedAsAdmin) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'edit-organization',
          params: {
            id: price.organization.id
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(price.organization.name) + "\n        ")]) : _c('span', [_vm._v(_vm._s(price.organization.name))])], 1) : _c('td', {
      staticClass: "uk-text-muted"
    }, [_c('text-placeholder')], 1), _vm._v(" "), _c('td', {
      staticClass: "uk-text-right"
    }, [_c('price', {
      attrs: {
        "value": price.value,
        "was": price.type === 'WAS'
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(_vm.$t(("paymentFrequencies." + (price.paymentFrequency.toLowerCase())))) + "\n      ")]), _vm._v(" "), (_vm.showActions) ? _c('td', [_c('data-grid-actions', {
      on: {
        "edit": function($event) {
          _vm.onEditItem(index)
        },
        "remove": function($event) {
          _vm.onRemoveItem(index)
        }
      }
    })], 1) : _vm._e()])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a5260c0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/PriceTable.vue
// module id = 1934
// module chunks = 0